const BASE_URL = "";

export const API = {
  LOGIN: `${BASE_URL}/api/login`,
  PROFILE: `${BASE_URL}/api/profile`,
  CHILDREN: `${BASE_URL}/api/children`,
  BILL_FROM_NURSERY: `${BASE_URL}/api/bill/parent`,
  BILL_GET_NURSERY: `${BASE_URL}/api/bill/get-nursery-bill`,
  GRADING_DEV_AREA: `${BASE_URL}/api/grading/dev_area`,
  GRADING_DEV_AGE_BAND: `${BASE_URL}/api/grading/dev_age_band`,
  GRADING_DEV_MATTER: `${BASE_URL}/api/grading/dev_matter`,
  EVENTS: `${BASE_URL}/api/events`,
  GRADING_CHECKPOINT: `${BASE_URL}/api/grading/checkpoint`,
  GALLERY: `${BASE_URL}/api/gallery`,
  FINANCE_TRANSACTIONS: `${BASE_URL}/api/finance/transactions`,
  FINANCE: `${BASE_URL}/api/finance`,
  SETTING: `${BASE_URL}/api/setting`,
  ME: `${BASE_URL}/api/me`,
  PARENTS: `${BASE_URL}/api/parents`,
  STAFF: `${BASE_URL}/api/staff`,
  NEWSLETTER_ADD_ADMIN: `${BASE_URL}/api/newsletter/add/admin`,
  NEWSLETTER: `${BASE_URL}/api/newsletter`,
  NEWSLETTER_UPDATE: `${BASE_URL}/api/newsletter/update`,
  NEWSLETTER_DELETE: `${BASE_URL}/api/newsletter/delete`,
  MENU: `${BASE_URL}/api/menu`,
  MENU_ADD: `${BASE_URL}/api/menu/add`,
  MENU_UPDATE: `${BASE_URL}/api/menu/update`,
  MENU_DELETE: `${BASE_URL}/api/menu/delete`,
  MENU_POST_DAY: `${BASE_URL}/api/menu/post-day`,
  ATTENDANCE_ADD: `${BASE_URL}/api/attendance/add`,
  ATTENDANCE_UPDATE: `${BASE_URL}/api/attendance/update`,
  ATTENDANCE_DELETE: `${BASE_URL}/api/attendance/delete`,
  ATTENDANCE: `${BASE_URL}/api/attendance`,
  USERS_CHILD: `${BASE_URL}/api/users/child`,
  CLASSROOM: `${BASE_URL}/api/classroom`,
  CLASSROOM_ADD: `${BASE_URL}/api/classroom/add`,
  CLASSROOM_UPDATE: `${BASE_URL}/api/classroom/update`,
  USERS: `${BASE_URL}/api/users`,
  USERS_UPDATE_PASSWORD: `${BASE_URL}/api/users/update-password`,
  CHILDREN_DELETE_CHILD: `${BASE_URL}/api/children/delete-child`,
  USERS_UPDATE_NURSERY: `${BASE_URL}/api/users/updateNursery`,
  BILL: `${BASE_URL}/api/bill`,
  BILL_TRANSACTIONS: `${BASE_URL}/api/bill/transactions`,
  BILL_CHECKOUT: `${BASE_URL}/api/bill/checkout`,
  BILL_CHECKOUT_PARENT: `${BASE_URL}/api/bill/checkout-parent`,
  WITHDRAW: `${BASE_URL}/api/withdraw`,
  WITHDRAW_ADD: `${BASE_URL}/api/withdraw/add`,
  REPORT_ADD: `${BASE_URL}/api/report/add`,
  REPORT: `${BASE_URL}/api/report`,
  REPORT_DOWNLOAD: `${BASE_URL}/api/report/download`,
  CURRENCY_CURRENCIES: `${BASE_URL}/api/currency/currencies`,
  REGION: `${BASE_URL}/api/region`,
  BILL_PAYMENT_SUMMARY: `${BASE_URL}/api/bill/payment-summary`,
} as const;
